export const DEFAULT_ATTRS: Attrs = {
	_enabled: false,
	propertyId: '',
	propertyName: '',
};

export type Attrs = {
	readonly _enabled: boolean;
	readonly propertyId: string;
	readonly propertyName: string;
};

export type SetAttrs = ( attrs: Partial< Attrs > ) => void;

// ============
// HELPER TYPES
// ============

export type GA4Property = {
	readonly id: string;
	readonly name: string;
};

export type ConnectionMode =
	| 'init'
	| 'awaiting-authorization'
	| 'property-retrieval'
	| 'property-selection'
	| 'ga4-property-id';
